import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
import classNames from 'classnames/bind';

import { setCheckoutDescription } from '../../../../state/modules/order/actions';

// Components
import Collapse from '../../../Collapse';
import ToggleArrow from '../../../ToggleArrow';
import TextareaField from '../../../TextareaField/DesktopView';

// Styles
import styles from './CommentField.styl';

const cx = classNames.bind(styles);

export default function CommentField() {
  const intl = useIntl();
  const dispatch = useDispatch();
  const deliveryType = useSelector(state => state.order.checkout.deliveryType);
  const description = useSelector(state => state.order.checkout.description);
  const [isOpen, setIsOpen] = useState(Boolean(description));

  const commentIndex = deliveryType === 'delivery' ? 1 : 2;

  const toggle = () => {
    setIsOpen(prev => !prev);
  };

  useEffect(() => {
    if (!isOpen && Boolean(description)) {
      setIsOpen(true);
    }
  }, [description]);

  return (
    <div className={cx('CommentField')}>
      <button
        className={cx('CommentField__button')}
        onClick={toggle}
        onKeyDown={e => e.key === 'Enter' && toggle()}
        type="button"
      >
        {intl.formatMessage({ id: `order.comment${commentIndex}` })}
        <ToggleArrow className={cx('CommentField__arrow')} isOpen={isOpen} />
      </button>
      <Collapse isOpen={isOpen}>
        <TextareaField
          className={cx('CommentField__textarea')}
          placeholder={intl.formatMessage({ id: `order.comment.placeholder${commentIndex}` })}
          name="comment"
          value={description}
          onChange={e => dispatch(setCheckoutDescription(e.target.value))}
        />
      </Collapse>
    </div>
  );
}
